export class Data {
}
//# sourceMappingURL=Data.js.map